import React from 'react';
import { Accordion } from './Accordion';
export function ProfessionalPlan() {
  return <section className="bg-navy text-white py-16 px-4" data-id="element-191">
      <div className="max-w-[720px] mx-auto" data-id="element-192">
        <div className="text-center mb-10" data-id="element-193">
          <span className="inline-block bg-gold text-navy text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wide" data-id="element-194">
            ⭐ Exclusivo del Plan Profesional
          </span>
          <h2 className="text-2xl md:text-3xl font-bold mb-3 leading-tight" data-id="element-195">
            Tu plata trabajando para vos. Sin improvisar.
          </h2>
          <p className="text-[15px] text-white/70 max-w-[500px] mx-auto" data-id="element-196">
            Para quienes quieren ir más allá del método base y construir
            patrimonio real a largo plazo.
          </p>
        </div>

        <div className="flex flex-col gap-4 mb-8" data-id="element-197">
          <Accordion title={<span className="font-bold text-[15px]" data-id="element-199">
                Tomo 7 — Segundo Ingreso
              </span>} icon={<span data-id="element-200">🚀</span>} className="border-gold/30 bg-gold/5" defaultOpen={true} data-id="element-198">
            <div className="text-[14px] text-white/80 space-y-2" data-id="element-201">
              <p data-id="element-202">
                Las 5 opciones más realistas para empezar a generar plata extra
              </p>
              <p data-id="element-203">· Plan de los primeros 7 días</p>
              <p data-id="element-204">· Integración al sistema de 3 cuentas</p>
            </div>
          </Accordion>

          <Accordion title={<span className="font-bold text-[15px]" data-id="element-206">
                Tomo 8 — Libertad Financiera Real
              </span>} icon={<span data-id="element-207">⭐</span>} className="border-gold/30 bg-gold/5" data-id="element-205">
            <div className="text-[14px] text-white/80 space-y-2" data-id="element-208">
              <p data-id="element-209">Las 4 etapas del camino a la libertad</p>
              <p data-id="element-210">· Tu número personal calculado</p>
              <p data-id="element-211">· Portafolio de inversión a 5 años</p>
            </div>
          </Accordion>
        </div>

        <p className="text-center text-[13px] text-white/50 italic" data-id="element-212">
          También incluye: Acceso a las 2 herramientas exclusivas más demandadas
          del sistema completo
        </p>
      </div>
    </section>;
}